import { Injectable } from '@angular/core';
import { storage_keys } from './storage.keys';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  id = "space-jammit-universe";

  private savedData: any = {};

  constructor() { }

  private isStorageAvailable(): boolean {
    return typeof localStorage !== 'undefined';
  }

  private encrypt(data: any) {
    let doubleStrigifiedData = JSON.stringify(JSON.stringify(data));
    let encryptedData = CryptoJS.AES.encrypt(doubleStrigifiedData, this.id).toString();
    return encryptedData;
  }

  private decrypt(encrytedData: any, encrytedDataLocation: string) {
    let data = "";
    if (encrytedData) {
      let bytes = CryptoJS.AES.decrypt(encrytedData, this.id);
      data = bytes.toString(CryptoJS.enc.Utf8);
      if (!data) {
        this.removeItem(encrytedDataLocation)
      }
    }
    return data ? JSON.parse(JSON.parse(data)) : "";
  }

  public getSavedData() {
    this.savedData = {};
    if (!this.isStorageAvailable()) {
      return this.savedData;
    }

    Object.keys(storage_keys).forEach(
      (key) => {
        if (key) {
          let data = this.get(storage_keys[key])
          if (data) {
            this.savedData[storage_keys[key]] = data;
          }
        }
      }
    );

    return this.savedData;
  }

  public set(key: string, data: any) {
    if (!data || !this.isStorageAvailable()) {
      return;
    }
    return new Promise((resolve, reject) => {
      let encryptedData = this.encrypt(data);
      resolve(localStorage.setItem(key, encryptedData));
    });
  }

  get(key: string) {
    if (!this.isStorageAvailable()) {
      return '';
    }
    return this.decrypt(localStorage.getItem(key), key);
  }

  public removeItem(key: string) {
    if (!this.isStorageAvailable()) {
      return;
    }
    return localStorage.removeItem(key);
  }

  private clearStorage() {
    if (this.isStorageAvailable()) {
      localStorage.clear();
    }
  }

  public clearStorageForLogout() {
    return new Promise((resolve, reject) => {
      if (!this.isStorageAvailable()) {
        resolve(true);
        return;
      }

      let count = 0
      Object.keys(storage_keys).forEach(
        (key) => {
          // if (key && storage_keys[key] !== storage_keys.lastSelectedLanguage && storage_keys[key] !== storage_keys.rememberMe) {
          this.removeItem(storage_keys[key]);
          count++;
          // }
        }
      );
      // Clear additional plain localStorage items
      localStorage.removeItem('galaxyData');
      localStorage.removeItem('pGalaxyData');
      localStorage.removeItem('app_status');
      if (count === Object.keys(storage_keys).length) {
        resolve(true);
      }
    })
  }
}
